module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82af801032eddde66a0163e50fcfe095.png";